export default __webpack_public_path__ + "static/media/mini-logo.29c46971.png";